import { post } from "./utils";

export const copyApplication = async (url: string) => {
  return await post(url, null);
};
